var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEv = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "ev_svg__a",
  d: "M0 .23v28h13.1v-28z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(13 6)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ev_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ev_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  strokeLinecap: "square",
  strokeLinejoin: "bevel",
  d: "M13.1 12.73H8V.23l-8 15.5h5.1v12.5z",
  mask: "url(#ev_svg__b)"
}))));
export default SvgEv;